import Model from './Model'

export default class ProductTest extends Model {
    resource()
    {
        return 'product-tests'
    }

    close()
    {
        this.action = 'finish';
        return this.save();
    }
}